/**
 * InfoNote: nota informativa al pie de una sección con icono.
 *
 * Sprint 14 S14-06b. Patrón nuevo (no en el handoff oficial). Sirve para
 * explicaciones contextuales tipo "Por privacidad mostramos tu RUT
 * parcialmente. Para actualizar contacta a la Comisión." que viven al
 * pie de una `Section`.
 *
 * Visual sobrio alineado al handoff: texto sm color muted, icono pequeño
 * al inicio. Sin fondo de card propio (el wrap visual es la `Section`
 * que la contiene).
 *
 * Uso:
 *   <Section>
 *     <SectionHead title="Datos personales" />
 *     <DataList>...</DataList>
 *     <InfoNote>Por privacidad mostramos tu RUT parcialmente.</InfoNote>
 *   </Section>
 *
 * Para icono custom, pasarlo como prop:
 *   <InfoNote icon={<LockIcon />}>Datos sensibles</InfoNote>
 */
import type { ReactNode } from 'react';

interface InfoNoteProps {
  children: ReactNode;
  /** Icono al inicio. Default: icono de información (círculo con i). */
  icon?: ReactNode;
  className?: string;
}

export function InfoNote({ children, icon, className = '' }: InfoNoteProps) {
  return (
    <div
      className={`flex items-start gap-2 mt-3 text-sm text-text-muted ${className}`.trim()}
      role="note"
    >
      <span className="flex-shrink-0 mt-[2px]" aria-hidden="true">
        {icon ?? <DefaultInfoIcon />}
      </span>
      <span>{children}</span>
    </div>
  );
}

function DefaultInfoIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="14"
      height="14"
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <line x1="12" y1="8" x2="12" y2="8.01" />
    </svg>
  );
}
